class PurchaseAssurance extends HTMLElement {
  connectedCallback() {
    this.shippingText = this.querySelector('[data-purchase-shipping-text]');
    this.threshold = Number(this.dataset.thresholdCents || 0);
    this.paidText = this.dataset.paidShippingText || '';
    this.freeText = this.dataset.freeShippingText || '';
    this.update(Number(this.dataset.priceCents || 0));

    const productForm = this.closest('product-info')?.querySelector('product-form');
    if (productForm) {
      productForm.addEventListener('variant:change', (event) => {
        const price = Number(event.detail?.variant?.price || 0);
        if (price) this.update(price);
      });
    }
  }

  update(price) {
    if (!this.shippingText) return;
    const qualifies = this.threshold === 0 || price >= this.threshold;
    this.shippingText.textContent = qualifies ? this.freeText : this.paidText;
  }
}

if (!customElements.get('purchase-assurance')) {
  customElements.define('purchase-assurance', PurchaseAssurance);
}
